import { create, RequestMethod, TApiClient } from '@assetmark/ui-kit/dist/utils/api-client.utils';
import { RoutingUtils } from '@assetmark/ui-kit/dist/utils/routing.utils';
import { history } from '../history';
import '@assetmark/ui-kit/dist/rx';

export const application$ = RoutingUtils.route$
	.run(history)
	.map(route => (route.location.pathname.startsWith('/advisor-console') ? 'IPM' : 'IPA'))
	.toProperty();

export const buildHeaders = () => ({
	'X-Application': 'WBLP',
});

const createLeadAPIClient = (baseHref: string): TApiClient => {
	const client$ = application$.map(() => create(baseHref, buildHeaders())).toProperty();
	const error$ = client$.switchMap(client => client.error$);
	return {
		RequestMethod,
		error$,
		request: request => client$.take(1).switchMap(client => client.request(request)),
		get: (url, query) => client$.take(1).switchMap(client => client.get(url, query)),
		post: (url, body) => client$.take(1).switchMap(client => client.post(url, body)),
		put: (url, body) => client$.take(1).switchMap(client => client.put(url, body)),
		remove: (url, query) => client$.take(1).switchMap(client => client.remove(url, query)),
	};
};

const baseClient = createLeadAPIClient('/');
//todo: use type-di
export const ApiClient = baseClient;
export const DasApiClient = baseClient;
export const UserApiClient = baseClient;

// Stream of all API clients errors.
export const apiClientsErrors$ = baseClient.error$;
